import React from 'react';

import BrowserVerificationComponent from './components/BrowserVerificationComponent';
import useBrowserVerification from './components/useBrowserVerification';

const BrowserVerificationPage = () => {
    useBrowserVerification();

    return <BrowserVerificationComponent />;
};

export default BrowserVerificationPage;
